import MatchComponent from './Match';

const Match = MatchComponent;

export default Match;